import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'selectSearch',
})
@Injectable()
export class SelectSearchPipe implements PipeTransform {
    transform(items: any[], search: string): any[] {
        if (!items || items.length === 0) { return []; }
        if (!search) { return items; }
        return items.filter((item: any) => item.value.toLowerCase().indexOf(search.toLowerCase()) > -1);
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/select-search.pipe.ts